import { videoJsPlayer } from '../video/videoJsPlayer'

SOPHIA.videoJsPlayer = videoJsPlayer
